module.exports = __webpack_public_path__ + "img/img_futa_chainstitch.3d43cfb5.png";